import { setUsrAppRefreshParams } from '@jfs/network'
import { useNavigation, useRoute } from '@react-navigation/core'
import { useEffect } from 'react'
import { Container } from '../../comps/Container'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { AppHeaderTransformer, extendAppSession } from '../../network/ExtendAppSession'
import { extendUserSession, HeaderTransformer } from '../../network/ExtendUserSession'
import { fireAllScheduledEvent } from '../../network/sendEvent'
import { getWindow, nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { getErrorMessage, isOTPRequiredChannel } from '../../util/utill'
// import { getFavoriteTransactionsBCApi } from '../../network/BillPaymentsService/getFavoriteTransactionsBC'

const ORDER_VALUE_KEY = 'pending_order_value'
const ORDER_ID_KEY = 'testing_order_id'
const AGENT_MOBILE = 'agent_mobile'

export const LoadInitialsScreen = () => {
  const navigation = useNavigation()
  const {
    isMaskedAadhaarAvailable,
    loadInitialsAsync,
    updateInitalAgentInfo,
    updateDeviceAppInfo,
    channelId,
    updateBCAppSessionData,
    updateAppType,
    appType,
    userAccessToken,
    userRefreshToken,
    appAccessToken,
    appRefreshToken,
    clientId,
    CHANNEL_ID,
    mobileNO,
    updateSessionData,
    getAgentLocationInfo,
    checkWhetherAgentExists,
    fetchFavoriteTransactionsV2BC,
    getProductListBC,
    fetchFavoriteTransactionsBC,
    agentOnboarding,
    orderId,
  } = useStores((root) => ({
    isMaskedAadhaarAvailable: root.agent.isMaskedAadhaarAvailable,
    loadInitialsAsync: root.agent.loadInitialsAsync,
    updateInitalAgentInfo: root.agent.updateInitalAgentInfo,
    updateDeviceAppInfo: root.agent.updateDeviceAppInfo,
    updateBCAppSessionData: root.bcAppInfo.updateBCAppSessionData,
    channelId: root.agent.session.CHANNEL_ID,
    updateAppType: root.consents.updateAppType,
    appType: root.consents.appType,
    userAccessToken: root.agent.session.userAccessToken,
    userRefreshToken: root.agent.session.userRefreshToken,
    appAccessToken: root.agent.session.appAccessToken,
    appRefreshToken: root.agent.session.appRefreshToken,
    clientId: root.agent.CLIENT_ID,
    CHANNEL_ID: root.agent.session.CHANNEL_ID,
    mobileNO: root.agent.agentInfo.agentUserLoginId,
    updateSessionData: root.agent.updateSessionData,
    getAgentLocationInfo: root.agent.getAgentLocationInfo,
    // fetchDeviceLocation: root.agent.fetchDeviceLocation,
    checkWhetherAgentExists: root.BillPaymentAgentOnboard.checkWhetherAgentExists,
    fetchFavoriteTransactionsV2BC: root.BillPaymentAgentOnboard.fetchFavoriteTransactionsBC,
    getProductListBC: root.BillPaymentAgentOnboard.getProductListBC,
    fetchFavoriteTransactionsBC: root.BillPaymentAgentOnboard.fetchFavoriteTransactionsBC,
    agentOnboarding: root.BillPaymentAgentOnboard.agentOnboarding,
    orderId: root.BillPaymentAgentOnboard.orderId,
  }))

  const [lazyLoadInitialsAsync, loadInitialsAsyncHandler] = useLazyApiData(loadInitialsAsync)
  // const [latValue, setLatValue] = useState(null)
  // const [longValue, setLongValue] = useState(null)
  // console.log(latValue, longValue, "latandlongvalue:::")

  const sessionStorage_order_value = sessionStorage.getItem(ORDER_VALUE_KEY)
  const localStorage_order_value = localStorage.getItem(ORDER_VALUE_KEY)
  const agent_mobile_no = RootStore.agent.agentInfo.agentMobileNumber
  const savedOrderId = sessionStorage.getItem(ORDER_ID_KEY)
  const localStorage_agent_mobile_no = localStorage.getItem(AGENT_MOBILE)

  console.log(
    ' localStorage_agent_User_login_id localStorage_agent_mobile_no sessionStorage_order_value localStorage_order_value ',
    localStorage_agent_mobile_no,
    sessionStorage_order_value,
    localStorage_order_value,
  )

  useEffect(() => {
    console.log('htag setUsrAppRefreshParams')
    console.log('htag setUsrAppRefreshParams')
    console.log('LoadInitialScreen Component')
    setUsrAppRefreshParams(
      extendUserSession(userAccessToken, userRefreshToken, CHANNEL_ID, mobileNO),
      HeaderTransformer,
      extendAppSession(appAccessToken, appRefreshToken, clientId, CHANNEL_ID),
      AppHeaderTransformer,
    )
  }, [userAccessToken, userRefreshToken, appAccessToken, appRefreshToken, CHANNEL_ID, clientId, mobileNO])

  //Get the session data here.
  const onAgentInfoCaptured = (data: any) => {
    console.log('aeps timing onAgentInfoCaptured called time ' + new Date().toISOString())
    console.log('htag inside onAgentInfoCaptured')
    const agentInfo = JSON.parse(data)
    console.log('data from SDK::', agentInfo)
    const newSessionData = agentInfo.SESSION_DATA
    const parsedSessionData: any = window.atob(newSessionData)
    const decodedSession: any = JSON.parse(parsedSessionData)
    console.log(decodedSession, 'data from SDK::', agentInfo)
    updateInitalAgentInfo(
      'fca026a0b4af38bbb394b041bb55414a',
      agentInfo.CHANNEL_ID,
      agentInfo.AGENT_ID,
      decodedSession.encToken,
      decodedSession.encKey,
      decodedSession.parentOrigin,
      decodedSession.transactionType,
      decodedSession.type,
    )
    setUsrAppRefreshParams(
      extendUserSession(userAccessToken, userRefreshToken, CHANNEL_ID, mobileNO),
      HeaderTransformer,
      extendAppSession(appAccessToken, appRefreshToken, clientId, CHANNEL_ID),
      AppHeaderTransformer,
    )
    const sessionData = agentInfo.SESSION_DATA
    let lat = ''
    let long = ''

    if (sessionData != null && sessionData !== undefined && sessionData.length > 0) {
      const parsedSessionData: any = window.atob(sessionData)
      const parsedLatLongData: any = JSON.parse(parsedSessionData)
      // console.log(parsedSessionData, "parsedSessionData::::",parsedSessionData)
      // lat = parsedLatLongData?.lat?.toString() ?? '';
      // long = parsedLatLongData?.long?.toString() ?? '';
      // setLatValue(lat)
      // setLongValue(long)
      // const lat = parsedLatLongData?.lat?.toString() ?? '';
      // const long = parsedLatLongData?.long?.toString() ?? '';
      // console.log(lat, long, "latlongcheck::::")
      updateAppType(JSON.parse(parsedSessionData)?.type?.toString() ?? '0')
      updateBCAppSessionData(
        JSON.parse(parsedSessionData)?.accessToken,
        JSON.parse(parsedSessionData)?.userIdentifierToken,
        JSON.parse(parsedSessionData)?.authenticationToken,
      )
      // console.log(latValue, longValue, "loadlatandlong:::")
    }
    console.log('See what value of sessionData', sessionData, agentInfo)
    // setTimeout(() => {
    lazyLoadInitialsAsync()
    // },80000)
  }

  // useEffect(() => {
  //   window.localStorage.setItem('ep_lat', latValue)
  //   window.localStorage.setItem('ep_long', longValue)
  // }, [latValue, longValue])

  // useEffect(() => {
  //   if (latValue && longValue) { getAgentLocationInfo(latValue, longValue); console.log('insideif') }

  // }, [latValue, longValue])

  const onAppInfoCaptured = (data: any) => {
    console.log('aeps timing onAppInfoCaptured called time ' + new Date().toISOString())
    const appInfo = JSON.parse(data)
    updateDeviceAppInfo(appInfo)
  }
  useEffect(() => {
    if (appType === '2') {
      navigation.setOptions({ headerTitle: 'Refund Deposit' })
    }
  }, [appType, navigation])

  useEffect(() => {
    updateSessionData()
    if (getWindow().AepsWebViewInterface) {
      console.log('aeps timing initialting native onAgentInfoCaptured time ' + new Date().toISOString())
      nativeJSComm(nativeJSMapper.getAgentInfo, onAgentInfoCaptured)
      nativeJSComm(nativeJSMapper.getAppInfo, onAppInfoCaptured)
    } else {
      const { REACT_APP_JFS_CLIENT_ID } = process.env
      onAgentInfoCaptured(
        JSON.stringify({ CLIENT_ID: REACT_APP_JFS_CLIENT_ID, CHANNEL_ID: '3155', AGENT_ID: '2000001533' }),
      )
      // pp JSON.stringify({ CLIENT_ID: '663eb0dac6b8f1a426b5639e88ecf11c', CHANNEL_ID: '8030', AGENT_ID: '2000342187' }),
      // sit         JSON.stringify({ CLIENT_ID: '1d62d6bbb7d99e53057424ec9e23951f', CHANNEL_ID: '8030', AGENT_ID: '2000001533' }),
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //BBPS check agent initial flow
  const route: any = useRoute()
  const [doesAgentExists, agentExistsHandler] = useLazyApiData(checkWhetherAgentExists)
  // const [fetchFavoriteVC, fetchFavoriteVCData] = useLazyApiData(fetchFavoriteTransactionsV2BC)
  // const [getProductList, getProductListBCOnboard] = useLazyApiData(getProductListBC)
  // const [fetchFavoriteTransaction, fetchFavoriteTransactionOnboard] = useLazyApiData(fetchFavoriteTransactionsBC)
  // const [agentOnboard, agentOnboardBC] = useLazyApiData(agentOnboarding)

  console.log(doesAgentExists, 'doesAgentExists::')

  useEffect(() => {
    if (appType === '3') {
      console.log('BBPS flow: Scheduling checkWhetherAgentExists API call in 30 seconds...')
      const timerId = setTimeout(() => {
        doesAgentExists({})
        console.log('apicalleddd:::::')
        // console.log('console running checkWhetherAgentExists doesAgentExists function SearchAgentAPI')
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [appType, doesAgentExists])

  // useEffect(() => {
  //   if (appType === '3') {
  //     // console.log('BBPS flow: Scheduling checkWhetherAgentExists API call in 30 seconds...')
  //     const timerId = setTimeout(() => {
  //       // agentOnboard({})
  //       // console.log('apicalleddd:::::')
  //       // console.log('console running checkWhetherAgentExists doesAgentExists function SearchAgentAPI')
  //     }, 30000)
  //     return () => clearTimeout(timerId)
  //   }
  // }, [appType, agentOnboard])

  // useEffect(() => {
  //   if (appType === '3') {
  //     // console.log('BBPS flow: Scheduling checkWhetherAgentExists API call in 30 seconds...')
  //     const timerId = setTimeout(() => {
  //       // getProductList({})
  //       // console.log('apicalleddd:::::')
  //     }, 30000)
  //     return () => clearTimeout(timerId)
  //   }
  // }, [appType, getProductList])

  // useEffect(() => {
  //   if (appType === '3') {
  //     console.log('BBPS flow: Scheduling checkWhetherAgentExists API call in 30 seconds...')
  //     const timerId = setTimeout(() => {
  //       fetchFavoriteTransaction({})
  //       console.log('apicalleddd:::::')
  //     }, 30000)
  //     return () => clearTimeout(timerId)
  //   }
  // }, [appType, fetchFavoriteTransaction])

  // useEffect(() => {
  //   if (appType === '3') {
  //     // console.log('BBPS flow: Scheduling checkWhetherAgentExists API call in 30 seconds...')
  //     const timerId = setTimeout(() => {
  //       // fetchFavoriteVC({})
  //       // console.log('apicalleddd:::::')
  //     }, 30000)
  //     return () => clearTimeout(timerId)
  //   }
  // }, [appType, fetchFavoriteVC])

  // useEffect(() => {
  //   if (agentExistsHandler?.state === 'fulfilled') {
  //     const agentExistsHandlercheck = agentExistsHandler
  //     console.log(agentExistsHandlercheck, 'agentExistsHandlercheck:')
  //     const agentData = agentExistsHandler?.data
  //     console.log(agentData, 'agentData::')
  //     const agentStatus = agentExistsHandler?.data?.responseObj?.agent?.agentStatus
  //     console.log(agentStatus, 'agentStatus::')
  //     if (agentStatus) {
  //       switch (agentStatus.reasonCode) {
  //         case '0':
  //           console.log('BBPS flow: Agent is active. Navigating to BBPS Home screen.')
  //           navigation.reset({
  //             index: 0,
  //             routes: [{ name: Screens.BBPS_HOME_SCREEN as never }],
  //           })
  //           break
  //         case '1':
  //           console.log('BBPS flow: Agent activation is pending. Navigating to a pending screen.')
  //           navigation.reset({
  //             index: 0,
  //             routes: [
  //               {
  //                 name: Screens.BBPS_PENDING_SCREEN as never,
  //                 params: {
  //                   message: agentStatus.reasonMessage,
  //                 },
  //               },
  //             ],
  //           })
  //           break
  //         case '2':
  //           console.log('BBPS flow: Agent not onboarded. Navigating to a not-onboarded screen.')
  //           navigation.reset({
  //             index: 0,
  //             routes: [
  //               {
  //                 name: Screens.BBPS_NOT_ONBOARDED_SCREEN as never,
  //                 params: {
  //                   message: agentStatus.reasonMessage,
  //                 },
  //               },
  //             ],
  //           })
  //           break
  //       }
  //     }
  //   }
  // }, [agentExistsHandler?.state, navigation, route.params?.type])
  // console.log('checkdmttttt::::')

  useEffect(() => {
    console.log('appType', appType)
    if (loadInitialsAsyncHandler.state === 'fulfilled') {
      setTimeout(() => {
        getAgentLocationInfo()
        console.log(getAgentLocationInfo(), 'callcheck::::::')
        // fetchDeviceLocation()
        // console.log(fetchDeviceLocation(), 'fetchdevicelocationcalled:::')
        fireAllScheduledEvent()
      }, 1500)
      if (appType === '3' && localStorage_order_value && localStorage_agent_mobile_no === agent_mobile_no) {
        console.log(
          'Recovery Flow: Pending Order ID found in localStorage_order_value: sessionStorage_order_value',
          localStorage_order_value,
          sessionStorage_order_value,
        )
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Screens.PaymentProcessingScreen as never,
              params: { orderId: orderId, isRecovery: true }, // Pass a flag to trigger auto-check
            },
          ],
        })
        return

        // Exit to prevent normal navigation
      } else if (appType === '0') {
        navigation.reset({
          index: 0,
          routes: [
            {
              name: (!isMaskedAadhaarAvailable()
                ? Screens.ENTER_AADHAAR_CARD
                : isOTPRequiredChannel(channelId)
                  ? Screens.ENTER_AADHAAR_OTP
                  : Screens.SCAN_FINGERPRINT) as never,
            },
          ],
        })
      } else if (appType === '1') {
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Screens.DOMESTIC_MONEY_TRANSFER_HOME_SCREEN as never,
              params: {
                type: 'RESET_LOGIN_STACK',
              },
            },
          ],
        })
      } else if (appType === '2') {
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Screens.REFUND_CODE as never,
            },
          ],
        })
      } else if (appType === '3') {
        if (agentExistsHandler?.state === 'fulfilled') {
          // const agentExistsHandlercheck = agentExistsHandler
          // console.log(agentExistsHandlercheck, 'agentExistsHandlercheck:')
          const agentData = agentExistsHandler?.data
          console.log(agentData, 'agentData::')
          // const agentStatus = agentExistsHandler?.data?.responseObj?.agent?.agentStatus?.reasonCode
          const agentStatus = agentExistsHandler?.data?.reasonCode
          console.log('Avinash see what value of agentStatus', agentStatus)
          console.log('Avinash see what value of orderId', orderId)
          console.log('Avinash see what value of agentData', agentData)

          console.log(agentStatus, 'agentStatus:::::')
          navigation.reset({
            index: 0,
            routes: [
              {
                name:
                  agentStatus === '0'
                    ? (Screens.BBPS_HOME_SCREEN as never)
                    : agentStatus === '1'
                      ? (Screens.BBPS_LOAD_INITIAL as never)
                      : (Screens.BBPS_LOAD_INITIAL as never),
              },
            ],
          })
        } else {
          console.log(
            'BBPS flow: Since Search Agent API is failed So retrying checkWhetherAgentExists API call in 30 seconds...',
          )
          const timerId = setTimeout(() => {
            doesAgentExists({})
            console.log('apicalleddd:::::')
            // console.log('console running checkWhetherAgentExists doesAgentExists function SearchAgentAPI')
          }, 1000)
          return () => clearTimeout(timerId)
        }
        // console.log('yahi hame check karna')
      }
    }
  }, [appType, channelId, isMaskedAadhaarAvailable, loadInitialsAsyncHandler, navigation])

  return (
    <Container
      isLoading={loadInitialsAsyncHandler.state === 'pending'}
      errorMessage={getErrorMessage(loadInitialsAsyncHandler)}
      onRetry={lazyLoadInitialsAsync}
      showFooter={true}
      type={appType !== '0' ? 'refund' : 'default'}
    />
  )
}

// navigation.reset({
//             index: 0,
//             routes: [
//               {
//                 name:
//                   agentStatus === '0'
//                     ? (Screens.BBPS_HOME_SCREEN as never)
//                     : agentStatus === '1'
//                     ? (Screens.BBPS_LOAD_INITIAL as never)
//                     : (Screens.BBPS_LOAD_INITIAL as never),
//               },
//             ],
//           })

// navigation.reset({
//   index: 0,
//   routes: [
//     {
//       name:
//         agentStatus === '0'
//           ? (Screens.BBPS_HOME_SCREEN as never)
//           : agentStatus === '1'
//           ? (Screens.BBPS_LOAD_INITIAL as never)
//           : (Screens.BBPS_LOAD_INITIAL as never),
//     },
//   ],
// })
// navigation.reset({
//   index: 0,
//   routes: [
//     {
//       name:
//         agentStatus === '0'
//           ? (Screens.BBPS_HOME_SCREEN as never)
//           : agentStatus === '1'
//             ? (Screens.ADD_CUSTOMER as never)
//             : (Screens.BBPS_LOAD_INITIAL as never),
//     },
//   ],
// })
